(function() {
  'use strict';

  angular
    .module('factories.durationTrackingFactory', ['factories.storage'])
    .factory('DurationTrackingFactory', DurationTrackingFactory);

  DurationTrackingFactory.$inject = ['Storage'];

  function DurationTrackingFactory(Storage) {
    var durationTracker;
    var durationTrackingTimer;
    var interval = 1000;
    var currentFrameId;
    var durationTrackingKey = "durationTrackingKey";
    var durationTail = 0;
    var isTracking = false;

    /* we will write to LS every LSWritePeriod ms (or earlier if leaving the slide within LSWritePeriod */
    var LSWritePeriod = 600000;

    function instantiateTracker() {
      durationTracker = {
        startDurationTracking: startDurationTracking,
        getFrameDuration: getFrameDuration,
        cleanFrameDuration: cleanFrameDuration,
        getAllUnsavedIntervals: getAllUnsavedIntervals,
        stopDurationTracking: stopDurationTracking,
        clear: clear
      };
    }

    function startDurationTracking(frameId) {
      if (isTracking)
        stopDurationTracking();

      isTracking = true;
      durationTail = 0;
      currentFrameId = frameId;
      durationTrackingTimer = setInterval(timerHandler, interval);
    }

    function stopDurationTracking() {
      pushToLS();
      if (durationTrackingTimer)
        clearInterval(durationTrackingTimer);
      isTracking = false;
    }

    function timerHandler() {
      durationTail += interval;
      if (durationTail == LSWritePeriod) {
        pushToLS();
        durationTail = 0;
      }
    }

    function getFixedTailDuration() {
      return durationTail || interval;
    }

    function pushToLS() {
      if (!currentFrameId)
        return;

      var storedDurations = Storage.getValue(durationTrackingKey) || {};
      if (storedDurations[currentFrameId])
        storedDurations[currentFrameId] = storedDurations[currentFrameId] + getFixedTailDuration();
      else
        storedDurations[currentFrameId] = getFixedTailDuration();
      Storage.setValue(durationTrackingKey, storedDurations);
    }

    function getFrameDuration(frameId) {
      if (!frameId) return null;
      var storedDurations = Storage.getValue(durationTrackingKey);
      if (storedDurations && storedDurations[frameId])
        return createFrameDuration(frameId, storedDurations[frameId] + getFixedTailDuration());

      return createFrameDuration(frameId, getFixedTailDuration());
    }

    function cleanFrameDuration(frameId) {
      if (!frameId) return;
      var storedDurations = Storage.getValue(durationTrackingKey);
      if (storedDurations && storedDurations[frameId]) {
        delete storedDurations[frameId];
        Storage.setValue(durationTrackingKey, storedDurations);
      }
      clearInterval(durationTrackingTimer);
    }

    function getAllUnsavedIntervals() {
      var arr = [];
      var storedDurations = Storage.getValue(durationTrackingKey);
      _.each(storedDurations, function(duration, frameId) {
        arr.push(createFrameDuration(frameId, getFixedTailDuration()));
      });
      return arr;
    }

    function clear() {
      Storage.clearValue(durationTrackingKey);
    }

    function createFrameDuration(frameId, duration) {
      return {
        frameId: frameId,
        durationMilliseconds: duration
      };
    }

    if (!durationTracker)
      instantiateTracker();

    return durationTracker;
  }
})();
